import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { LoyaltyHero as Desc } from './desk'
import { LoyaltyHero as Mob } from './mob'

type Props = {
  images: TImages
}
export const Hero = ({ images }: Props) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
